import React from 'react';
import OTIcon from '../../../components/tag/OTIcon';
import { OTLink } from '../../../components/tag/OTLink';

function getInstructionName(instruction) {
  return instruction.toString().split('$')[0];
}

function getInstructionLink(instruction) {
  return instruction.toString().split('$')[1];
}

/**
 * Render instruction with given link and name
 *
 * @param name
 * @param link
 * @returns {*}
 * @constructor
 */
function Instruction({ name, link }) {
  return (
    <li style={{listStyleType: "disc"}}>
      <OTLink
        target="_blank"
        onClick={(e) => e.stopPropagation()}
        rel="noopener noreferrer"
        link={link}
        isExternal
        className="card-link"
      >
        {name}
      </OTLink>
    </li>
  );
}

/**
 * Render instructions for timeline item.
 *
 * @param props
 * @constructor
 */
function Instructions({ instructions }) {
    if (instructions == null) return null;

    return (
      <div className="span12">
          <ul className="timeline-frame-instructions-list">
              {instructions &&
              instructions.map((instruction, idx) => (
                  <Instruction
                      name={getInstructionName(instruction)}
                      link={getInstructionLink(instruction)}
                      key={idx}
                  />
              ))}
          </ul>
      </div>
    );
}

export default Instructions;
